import { apiClient } from './api';
import type { OHLCResponse } from '../types/tdSequential';

export const tdSequentialService = {
  /**
   * Fetch OHLC with TD Sequential data for a ticker
   * GET /api/market-data/ohlc-daily/{ticker}/?days_back=180&include_td=true
   */
  async fetchOHLC(ticker: string, daysBack: number = 180): Promise<OHLCResponse> {
    return apiClient.get<OHLCResponse>(
      `/api/market-data/ohlc-daily/${ticker.toUpperCase()}/`,
      { days_back: daysBack, include_td: true }
    );
  },
};
